import React, { useState, useEffect, useRef } from 'react';

import 'react-datepicker/dist/react-datepicker.css';
import './CustomDatePicker.css';
import {
  BagsBox,
  BagsTitleBox,
  BagsBodyBox,
  BagsTitle,
  IconEye,
  PreviewButton,
  SaleButton,
  ButtonWrap,
  FieldWrapper,

  Fields,

  VerticalBox,

  Categorie,
  Categories,
  QuantityButton,
  QuantityInputWrapper,
  IconInc,
  IconDec,
  InputCount,
  BGTitle,
  Label0,

  BagsStatus,
  Texts, Titles,
  IconWarn,
  IconBag,
  SubFieldWrapper,
  ChangeButton,
  TempLink,
  WrapIcon,
  IconReg,
  Textsp,
  DeleteButton,
  IconTrash,
  EditButton,
  IconEdit,
  IconDown,
  DeleteUse,
  DeleteUseItem,
  LabelBox,
  LabelText,
  Span,
  Span1,
  IconLabel,
  IconRepeat,
  IconCircleCrs,
  HorizontalBox3,
  IconMail,
  IconMobile,
  SubFieldWrapperBag,
  SubFieldWrapperDish,
  SubDish,
  OrderImg,
  OrderInfo,
  OrderTextWrap,
  CountTexts,
  OrderCountWrap,
  OrderCountSwitchWrap,
  CountTextsSwitch,
  Checkbox,
  CustomLabel,
  OrderTitle,
  OrderOptionText,
  OrderPriceText,
  OrderPriceWrap,
  OrderAmountText,
  TotalTop,
  TotalBottom,
  TotalBox,
  TotalBoxText1,
  TotalBoxText2,
  TotalBoxText3,
  TotalBoxText4,
  TotalBoxText5,
  OrderPriceText1
} from './ViewOrder.styled';
import { useFetchDiscountPercentQuery, useFetchPricesQuery } from '../../../redux/category/categoriesApi';
import { useFetchShopsQuery } from '../../../redux/shops/shopsApi';
// import { addDays, format, parse } from 'date-fns';
import { useDeleteBagMutation, useEditBagCountMutation, useEditBagDatesMutation, useEditBagMutation, useEditBagShopMutation, useGetBagQuery, usePublishBagMutation } from '../../../redux/bags/bagsApi';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSocket } from '../../../context/SocketContext';
import { determineBagParameters, formatDate, formatDateText, formatDateTimeRange, formatedRepeat, formatRepeat, returnStatus } from '../../../utils/function';
import BagModal from '../../modal/BagModal';
import ImageAnimation1 from 'components/layout/loader/ImageAnimation1';
import { showErrorToast, showInfoToast, showSuccessToast, showWarningToast } from 'utils/showToast';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../redux/auth/selectors';
import AllertFinance from 'components/modal/AllertFinance';
import { url1 } from 'components/other/terms';
import { io } from 'socket.io-client';
import { selectToken } from '../../../redux/auth/selectors';
import AllertPrro from 'components/modal/AllertPrro';
import { useAcceptDishReturnMutation, useCancelDishOrderMutation, useConfirmDishReturnMutation, useGetDishOrderQuery, useReportDishDoneMutation } from '../../../redux/dishorders/dishordersApi';
import { useCancelOrderMutation, useConfirmOrderMutation, useGetOrderQuery } from '../../../redux/orders/ordersApi';
import { skipToken } from '@reduxjs/toolkit/query';
import { BagsText } from 'components/settings/MarketingSettings/MarketingSettings.styled';
import FormatNumber from 'components/other/FormatNumber/FormatNumber';
import ReturnModal from 'components/modal/ReturnModal';
import { selectSocketEvent } from '../../../redux/app/appSlice';
import { isThisYear, isThursday } from 'date-fns';





const ViewOrder = () => {
  const token = useSelector(selectToken);
  const user = useSelector(selectUser);
  const socket = useSocket();
    const socketEvent = useSelector(selectSocketEvent);
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

const isDishOrder =
  new URLSearchParams(location.search).get('type') === 'dish';
  const deleteUseRef = useRef(null);
  const { data: shopsData, isLoading: isLoadingShop } = useFetchShopsQuery();

  const [shops, setShops] = useState([]);
  const { data: pricesData } = useFetchPricesQuery();

  const {
  data: dataDishorder,
    isLoading: isLoadingDishOrder, refetch:refetchDishOrder,
   isUninitialized: isDishUninit
} = useGetDishOrderQuery(id);

  const {
    data: dataOrder,
    isLoading: isLoadingOrder,
    refetch: refetchOrder,
      isUninitialized: isOrderUninit
     
  } = useGetOrderQuery( id);
    const { data: discontData, isLoading: isLoadingDiscont } = useFetchDiscountPercentQuery();
  const data = isDishOrder ? dataDishorder : dataOrder;
  const isLoading = isDishOrder ? isLoadingDishOrder : isLoadingOrder;
  const [reportDishDone] = useReportDishDoneMutation();
  const [confirmDishReturn] = useConfirmDishReturnMutation();
  const [cancelDishOrder] = useCancelDishOrderMutation();
    const [confirmOrder] = useAcceptDishReturnMutation();
  const [order, setOrder] = useState(null);
    const [orderId, setOrderId] = useState(null);
  const [paramBag, setParamBag] = useState({});
  const [priceBags, setPriceBags] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [bag, setBag] = useState(null);
const [isAllDishesDone , setIsAllDishesDone ] = useState(false);
  const [title, setTitle] = useState('');
  const [type, setType] = useState('');
  const [typeBtn, setTypeBtn] = useState('');
  const [isModalOpen2, setModalOpen2] = useState(false);
  const [isModalOpen3, setModalOpen3] = useState(false);
  const [amountWithoutDiscount, setAmountWithoutDiscount] = useState(0);
const [loadingDishes, setLoadingDishes] = useState(new Set());

  
  const isChoiceOrder = order?.shop?.id
  ? shops.some(
      shop =>
        shop.id === order.shop.id &&
        shop.choice_connected === true
    )
  : false;
useEffect(() => {
  if (!socket || !order?.id) return;
  if (isDishOrder && isDishUninit) return; // ще не завантажено
  if (!isDishOrder && isOrderUninit) return; // ще не завантажено

  const roomName = isDishOrder ? `dishorder${order.id}` : `order${order.id}`;
  socket.emit('join', { room: roomName });
  console.log(`🔵 Приєднано до кімнати ${roomName}`);

  const handleUpdate = () => {
    if (isDishOrder) refetchDishOrder?.();
    else refetchOrder?.();
  };

  socket.on('update', handleUpdate);

  return () => {
    socket.emit('leave', { room: roomName });
    socket.off('update', handleUpdate);
     console.log("⚪ leave order room:", roomName);
  };
}, [socket, order?.id, isDishOrder, isDishUninit, isOrderUninit,refetchDishOrder,refetchOrder]);
// useEffect(() => {
//   if (!socket || !id) return;

//   const roomId = isDishOrder
//     ? `dishorder${id}`
//     : `order${id}`;

//   socket.emit("join_room", roomId);
//   console.log("🔵 join order room:", roomId);

//   return () => {
//     socket.emit("leave_room", roomId);
//     console.log("⚪ leave order room:", roomId);
//   };
// }, [socket, id, isDishOrder]);

// useEffect(() => {
//   if (!socket) return;

//   const handleMessage = (data) => {
//     // перевірка, що це саме це замовлення
//     if (
//       data.object_id?.toString() !== id ||
//       data.type !== (isDishOrder ? "dishorder" : "order")
//     ) {
//       return;
//     }

//     console.log("📨 update current order:", data);

//     // 🔥 тригери оновлення
//     refetch?.();
//     refetchOrder?.();
//   };

//   socket.on("message", handleMessage);

//   return () => {
//     socket.off("message", handleMessage);
//   };
// }, [socket, id, isDishOrder, refetch, refetchOrder]);



  const handleOpenModal3 = () => {
    setModalOpen3(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModal3= () => {
    setModalOpen3(false);

    document.body.style.overflow = 'auto';

  };
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        handleCloseModal3();

      }
    };

    if (isModalOpen3) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen3]);
  
  const handleOpenModal2 = () => {
    setModalOpen2(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModal2 = () => {
    setModalOpen2(false);
    
    document.body.style.overflow = 'auto';
 
  };

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        handleCloseModal2();

      }
    };

    if (isModalOpen2) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen2]);

  const [isModalOpen, setModalOpen] = useState(false);
  const handleOpenModal = () => {
    document.body.style.overflow = 'hidden';
    document.querySelector('#myTargetDiv').style.overflowY = 'hidden';
console.log('<<ПОЧАТОК ДОСЛІДЖЕННЯ ЛОГІВ:>> ', );
    setModalOpen(true);
    
  };

  const handleCloseModal = () => {
    console.log('<<КІНЕЦЬ ДОСЛІДЖЕННЯ ЛОГІВ :>> ',);
    setModalOpen(false);
    setTitle("")
    document.body.style.overflow = 'auto';
    document.querySelector('#myTargetDiv').style.overflowY = 'auto';
    setType('')
  };

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        handleCloseModal();
        setType('')
      }
    };

    if (isModalOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen]);
  useEffect(() => {
    if (shopsData) {
      setShops(shopsData)
    }
  }, [shopsData]);

useEffect(() => {
  const currentOrder = isDishOrder ? dataDishorder : dataOrder;

  if (!currentOrder) return;

  setOrder(currentOrder);

  if (isDishOrder) {
    const dishes = Object.values(currentOrder.data || {});

    // ✔️ перевірка, чи всі страви готові
    const isAllDone =
      dishes.length > 0 && dishes.every(dish => dish.isDone === true);

    setIsAllDishesDone(isAllDone);

    // ===============================
    // 🔥 РОЗРАХУНОК СУМИ БЕЗ ЗНИЖКИ
    // ===============================
    const discount = currentOrder.discount_percent || 0;

    const totalWithoutDiscount = dishes.reduce((total, dish) => {
      // 1️⃣ ціна страви БЕЗ знижки
      const dishPriceWithoutDiscount =
        discount > 0
          ? Math.round(dish.price / ((100 - discount) / 100))
          : dish.price;

      // 2️⃣ сума опцій (без знижки)
      const optionsSum = dish.options
        ? Object.values(dish.options).reduce(
            (sum, option) =>
              sum + option.price * (option.count || 1),
            0
          )
        : 0;

      // 3️⃣ фінал по страві
      return (
        total +
        (dishPriceWithoutDiscount + optionsSum) *
          (dish.count || 1)
      );
    }, 0);

    setAmountWithoutDiscount(
      Number(totalWithoutDiscount.toFixed(2))
    );
  } else {
    setIsAllDishesDone(false);
    setAmountWithoutDiscount(0);
  }

  console.log('currentOrder:>> ', currentOrder);
}, [dataDishorder, dataOrder, isDishOrder]);




// useEffect(() => {
//   const currentOrder = isDishOrder ? dataDishorder : dataOrder;

//   if (!currentOrder) return;

//   setOrder(currentOrder);

//   if (isDishOrder) {
//     const dishes = Object.values(currentOrder.data || {});
//     const isAllDone =
//       dishes.length > 0 && dishes.every(dish => dish.isDone === true);

//     setIsAllDishesDone(isAllDone);
//   } else {
//     setIsAllDishesDone(false);
//   }

//   console.log('currentOrder:>> ', currentOrder);
// }, [dataDishorder, dataOrder, isDishOrder]);

  // useEffect(() => {
  //   if (bag1) {
  //     console.log(bag1)
  //     console.log('determineBagParameters(bag) :>> ', determineBagParameters(bag1));
  //    setBag(bag1)
  //     setParamBag(determineBagParameters(bag1))
  //     setQuantity(bag1.count)
  //   }
  // }, [bag1]);







  useEffect(() => {
    const handleClickOutside = (event) => {
      if (deleteUseRef.current && !deleteUseRef.current.contains(event.target)) {
        setTypeBtn(''); // Закрити меню
      }
    };

    if (typeBtn === 'visible') {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [typeBtn]);

   const statusColors = {
    hold: "var(--colors-primary-600)",        // Жовтий для "Викуплено"
    created: "var(--colors-warning-400)",     // Синій для "Заброньовано"
    waiting: "var(--colors-warning-400)",     // Помаранчевий для "Очікує на отримувача"
    cancelled: "var(--colors-grey-400)",   // Червоний для "Скасовано"
    unsuccessful: "var(--colors-error-400)", // Сірий для "Час вичерпано"
    done: "var(--colors-secondary-600)",
    ended: "var(--colors-error-400)",
     reverted: "var(--colors-grey-400)",// Зелений для "Товар отримано"
    refused: "var(--colors-error-400)",
    pending: "var(--colors-warning-500)",
  };
 const formatUAphone = (phone) => {
  if (!phone) return '';

  const digits = phone.replace(/\D/g, '');

  if (digits.length !== 10) return phone;

  return `+38 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 8)}-${digits.slice(8, 10)}`;
};

const handleDishDoneChange = async (dishId) => {
  // ❌ якщо вже в процесі — нічого не робимо
  if (loadingDishes.has(dishId)) return;

  setLoadingDishes(prev => new Set(prev).add(dishId));

  try {
    await reportDishDone({
      orderId: order.id,
      dishId,
    }).unwrap();
  } catch (e) {
    showErrorToast('Не вдалося оновити статус страви');
  } finally {
    setLoadingDishes(prev => {
      const next = new Set(prev);
      next.delete(dishId);
      return next;
    });
  }
}
  

  
  const handleCancel = async  () => {
  try {
    await cancelDishOrder(order.id).unwrap();
  } catch (e) {
    showErrorToast('Не вдалося скасувати замовлення');
  }
  }
  const handleConfirm = async  () => {
  try {
    await confirmOrder(order.id).unwrap();
  } catch (e) {
    showErrorToast('Не вдалося видати замовлення');
  }
  }



  return (
    <BagsBox>
      {isLoading || isLoadingShop ||isLoadingDiscont   ? <ImageAnimation1 /> : <>
        <BagsTitleBox>
          <BagsTitle>
            <BGTitle>Замовлення {order?.id} </BGTitle>
            <div style={{ display: 'flex', gap: '12px' }}> 

            <BagsStatus statusCol={statusColors[order?.status]}>{order?.statusName}</BagsStatus>
          </div>
          </BagsTitle>

          <ButtonWrap>
             <FormatNumber
                    number={order?.key}
                    color={'var(--colors-grey-900)'}
                  />
         {order?.status === 'pending' && !isChoiceOrder && (
  <SaleButton
    type="button"
    onClick={handleConfirm}
  >
    <Span1>Підтвердити замовлення</Span1>
  </SaleButton>
)}

{order?.status === 'pending' && isChoiceOrder && (
  <BagsText>
    Підтвердження замовлення здійснюється у застосунку ChoiceQR
  </BagsText>
)}
          </ButtonWrap>
        </BagsTitleBox>

        <BagsBodyBox>
          <Fields>

            <FieldWrapper>
         
              {isDishOrder ?
                (
                   <SubFieldWrapperDish>
                    {Object.values(order?.data || {}).map(dish => {
                        const optionsSum = dish.options
                              ? Object.values(dish.options).reduce(
                                  (sum, option) => sum + option.price * (option.count || 1),
                                  0
                                )
                              : 0;
                      return (
                        <SubDish key={dish.id} >
                          {dish?.picture&&<OrderImg src={dish?.picture} alt={dish.name} />}
                          <OrderInfo>
                            <OrderTextWrap>
                              <OrderTitle >{dish.name}</OrderTitle>
                              {dish.options && (<OrderOptionText>
                                {Object.values(dish.options)
                                  .map(option => option.count > 1 ? `${option.name} x ${option.count}` : option.name)
                                  .join(', ')
                                }
                                {/* + {optionsSum } грн */}
                              </OrderOptionText>)}
                              <OrderOptionText>{dish?.packing_price===0?`Вартість пакування входить у вартість страви`:`Пакування  -  ${dish?.packing_price} грн` }</OrderOptionText>
                              <OrderPriceWrap>
                                <OrderPriceText>{dish?.price} грн</OrderPriceText>
                                <OrderPriceText1>{Math.round(dish?.price / ((100 - (dish?.discount_percent? dish?.discount_percent:discontData)) / 100))} грн</OrderPriceText1>
                               
                              </OrderPriceWrap>
                             
                            </OrderTextWrap>
                            <OrderCountWrap  className={`${!dish?.isDone ? "":'done'} ${dish?.picture ?"":'none'}`} >
                              <CountTexts >{dish?.count} шт.</CountTexts>
                             {order?.status !== 'refused' &&
                                        !dish?.isDone &&
                                        !isChoiceOrder && (
                                          <OrderCountSwitchWrap
                                            className={dish?.picture ? "" : "none"}
                                          >
                                            <CountTextsSwitch
                                              className={dish?.picture ? "" : "none"}
                                            >
                                              Страва готова?
                                            </CountTextsSwitch>

                                            <Checkbox
                                              type="checkbox"
                                              id={`dish-${dish.id}`}
                                              checked={dish.isDone}
                                              disabled={loadingDishes.has(dish.id)}
                                              onChange={() => handleDishDoneChange(dish.id)}
                                            />

                                            <CustomLabel htmlFor={`dish-${dish.id}`} />
                                          </OrderCountSwitchWrap>
                                      )}
                                                                  </OrderCountWrap>
                          </OrderInfo>
                        </SubDish>
                      )
                    })}
                      </SubFieldWrapperDish>
                ) :
                (
                  <SubFieldWrapperBag>
                      <OrderImg src={order?.bag?.picture} alt={order?.bag?.name} />
                      <OrderInfo>
                        <OrderTextWrap>
                        <OrderTitle >{order?.bag?.name}</OrderTitle>
                        <OrderPriceWrap>
                          <OrderPriceText>{order?.bag?.price} грн</OrderPriceText>
                              <OrderAmountText>{ order?.bag?.old_price} грн</OrderAmountText>
                        </OrderPriceWrap>
                        </OrderTextWrap>
                        <CountTexts>{order?.count} шт.</CountTexts>
                      </OrderInfo>
                  </SubFieldWrapperBag>
                )
              }

            </FieldWrapper>


            <FieldWrapper>
              <SubFieldWrapper >
                <VerticalBox style={{ width: '100%' }}>
                  <TotalTop>
                    <TotalBox>
                      <TotalBoxText1>Разом</TotalBoxText1>
                      <TotalBoxText2>{isDishOrder?amountWithoutDiscount:order?.bag?.old_price*order?.count} грн</TotalBoxText2>
                    </TotalBox>
                    <TotalBox>
                      <TotalBoxText3>Знижка</TotalBoxText3>
                      <TotalBoxText3>{!isDishOrder?order?.bag?.old_price*order?.count-order?.bag?.price*order?.count:(amountWithoutDiscount- order?.amount).toFixed(1) } грн</TotalBoxText3>
                     </TotalBox>
                  </TotalTop>
                  <TotalBottom>
                    <TotalBox>
                      <TotalBoxText4>Всього:</TotalBoxText4>
                      <TotalBoxText5>{order?.amount} грн</TotalBoxText5>
                    </TotalBox>
                  </TotalBottom>

                  </VerticalBox>
              
              </SubFieldWrapper>

    
            </FieldWrapper>

          
            <FieldWrapper style={{ width: '100%' }}>
               <SubFieldWrapper style={{ width: 'calc((100% - 16px) / 2)', display: 'flex', flexWrap: 'wrap', alignItems: 'start', justifyContent: 'space-between' }} >
                <VerticalBox style={{ width: 'calc(100% - 131px)' }}>
                  <Titles>Час отримання</Titles>
                { isDishOrder ?( <Texts>Клієнт прийде по замовлення о {order?.time?.slice(0, 5)}</Texts>):
                  (<Texts>{order?.bag&&formatDateTimeRange(order?.bag?.datetime_from, order?.bag?.datetime_to, order?.bag?.schedule ? true : false)}</Texts>)}
                </VerticalBox>
              
              </SubFieldWrapper>



              <SubFieldWrapper style={{ width: 'calc((100% - 16px) / 2)' , display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }} >
                <VerticalBox style={{ width: 'calc(100% - 131px)' }}>
                  <Titles>Точка видачі</Titles>
                  <Texts>{order?.shop?.name}</Texts>
                  <Textsp>{order?.shop?.address}</Textsp>
                </VerticalBox>
              
              </SubFieldWrapper>
             
            </FieldWrapper>

         <FieldWrapper>
              <SubFieldWrapper>
                <Titles>Відомості про клієнта</Titles>
                <HorizontalBox3>
                  {order?.email && (<div style={{display:'flex',alignItems:'center'}}> <IconMail /><Texts>{order?.email}</Texts></div>)}
                  {order?.phone && (<div style={{display:'flex',alignItems:'center'}}> <IconMobile/><Texts>{formatUAphone(order?.phone)}</Texts></div>)}
                </HorizontalBox3>
               
               
              </SubFieldWrapper>

              <SubFieldWrapper>
                   <Titles>Інший отримувач</Titles>
             {order?.isTransferred ? <HorizontalBox3>
                  {/* {order?.transfer?.email && (<div style={{display:'flex',alignItems:'center'}}> <IconMail /><Texts>{order?.transfer?.email}</Texts></div>)} */}
                  {order?.transfer?.phone && (<div style={{display:'flex',alignItems:'center'}}> <IconMobile/><Texts>{formatUAphone(order?.transfer?.phone)}</Texts></div>)}
                </HorizontalBox3> : <Texts> - </Texts>}
              </SubFieldWrapper>
            </FieldWrapper>

         
              <FieldWrapper style={{ height: 'fit-content', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }} >
                       {order?.return && <DeleteButton  onClick={(e) => {
                        e.stopPropagation();
                        setOrderId(order.id);
                        handleOpenModal();
                       setType(!order?.bag ? 'dish' : 'bag');
                      }}><IconTrash />Повернення</DeleteButton>}
              {order?.status === "pending" && <EditButton onClick={handleCancel} style={!order?.return ? { width: '100%' } : {}} ><IconEdit /> Скасувати </EditButton>}
           
       
              </FieldWrapper>
            

         



          </Fields>
        </BagsBodyBox>
      </>}
        {
          isModalOpen  && (
            <ReturnModal onClose={handleCloseModal} orderId={orderId} type={type} />
          )
        }
    
      {/* {
        isModalOpen && !isLoadingShop && (
          <BagModal nqe={true} onClose={handleCloseModal} bag={bag} title={title} shopsData={shops} type={type} pointd={`${bag?.shop?.name} (${bag?.shop?.address})`} />
        )
      } */}
    </BagsBox >
  );
};

export default ViewOrder;